<template>
  <div class="p-reviews__item">
    <div class="p-reviews__header">
      <div class="p-reviews__label">{{ $t('pages.CompaniesCompetitorsReviews.competitors') }}</div>
      <p class="p-reviews__name">{{ review.attributes.competitor_name }}</p>
      <p class="p-reviews__note">{{ $t('pages.CompaniesCompetitorsReviews.myself') }}：<span>{{ review.attributes.store_name }}</span></p>
    </div>
    <div class="p-reviews__summary">
      <div class="p-reviews__site">
        <div class="p-reviews__site__icon">
          <KkSiteIcon :name="review.attributes.site_type" />
        </div>
        <div
          class="p-reviews__site__name"
          data-test="review_item_site_name"
          v-text="review.attributes.site_name"
        />
      </div>
      <div class="p-reviews__reviewRating">
        <div class="c-rating">
          <div class="c-rating__number">
            <template v-if="review.attributes.rating"> {{ review.attributes.rating }}</template>
            <template v-else>-</template>
          </div>
          <Star v-show="review.attributes.rating" :rating="review.attributes.rating" />
        </div>
      </div>
      <div class="p-reviews__postedDate" v-text="review.attributes.posted_at" />
      <div
        v-show="review.attributes.posted_at !== review.attributes.reviewer_edited_at"
        class="p-reviews__reviewerEditedDate"
        v-text="$t('pages.CompaniesCompetitorsReviews.updatedOn', { date: review.attributes.reviewer_edited_at })"
      />
    </div>
    <div class="p-reviews__content">
      <div class="p-reviews__title" v-text="review.attributes.title" />
      <!-- 本文 翻訳付き -->
      <div v-if="review.attributes.translation" class="translation">
        <div class="p-reviews__comment">
          <KkTag
            :label="$t('pages.CompaniesCompetitorsReviews.translation')"
            icon-name="ja"
            color="secondary"
            class="translation__tag"
          />
          <KkMore
            :text="review.attributes.translation.comment_ja"
            :keyword="searchQuery"
          />
        </div>
        <div class="p-reviews__comment translation--original">
          <KkTag
            :label="$t('pages.CompaniesCompetitorsReviews.originalText', { locale: $t(`locales.${review.attributes.translation.locale}`) })"
            icon-name="global"
            color="gray"
            class="translation__tag"
          />
          <KkMore
            :text="review.attributes.comment"
            :keyword="searchQuery"
          />
        </div>
      </div>
      <!-- 本文 原文のみ -->
      <template v-else>
        <div class="p-reviews__comment">
          <KkMore
            :text="review.attributes.comment"
            :keyword="searchQuery"
          />
        </div>
      </template>
      <div class="p-reviews__source">
        {{ $t('labels.source') }}
        <a
          :href="review.attributes.site_url"
          target="_blank"
          v-text="review.attributes.site_name"
        />
      </div>
      <KkReviewImages v-if="showReviewImages" :images="review.attributes.photos" :hide-report-link="true" class="reviewImage" />
    </div>
  </div>
</template>

<script>
import Star from '../Star.vue'
import { KkSiteIcon } from '../base'
import KkMore from '../base/KkMore/index.vue'
import KkTag from '../base/KkTag/index.vue'
import { KkReviewImages } from '../../domains/review'
import { mapGetters } from 'vuex'

export default {
  name: 'CompaniesReviews',
  components: {
    Star,
    KkMore,
    KkTag,
    KkReviewImages,
    KkSiteIcon
  },
  props: {
    review: {
      type: Object,
      required: true,
    },
    searchQuery: {
      type: String,
      default: '',
    }
  },
  computed: {
    ...mapGetters({
      isAdmin: 'companiesAccessibleApi/isAdmin',
      isEnterprisePlan: 'companiesCompany/isEnterprisePlan',
    }),
    showReviewImages() {
      return this.review.attributes.photos.length > 0 && this.isEnterprisePlan
    },
  },
}
</script>

<style lang="scss" scoped>
.translation {
  margin-top: 4px;

  &__tag {
    margin-bottom: 4px;
  }

  &--original {
    background-color: #F4F4F4;
    margin: 8px 0;
    padding: 16px;
    border-radius: 4px;
  }
}
.reviewImage {
  margin-top: 12px;
}
</style>
